import { Directive, Input, OnInit, HostListener } from '@angular/core';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import { FilterService, BaseFilterCellComponent } from '@progress/kendo-angular-grid';
@Directive({
    selector: '[kendogridFilter]'
})
export class KendoGridFilterDirective extends BaseFilterCellComponent implements OnInit {

    @Input() filter: CompositeFilterDescriptor;
    @Input() column: any;

    public get selectedValue(): any {
        const filter = this.filterByField(this.column.dataField);
        return filter ? filter.value : null;
    }
    public get defaultItem(): any {
        return {
            value: null,
            name: 'å¨é¨'
        };
    }

    constructor(
        private dropdownList: DropDownListComponent,
        public filterService: FilterService,
    ) {
        super(filterService);
    }

    ngOnInit() {
        this.dropdownList.valueField = 'value';
        this.dropdownList.textField = 'name';
        this.dropdownList.valuePrimitive = true;
        this.dropdownList.defaultItem = this.defaultItem;
        this.dropdownList.value = this.selectedValue;
        if (this.column.dataType === 'enum') {
            this.dropdownList.data = this.column.enumData;
        } else if (this.column.dataType === 'boolean') {
            this.dropdownList.data = [{ value: true, name: 'æ¯' }, { value: false, name: 'å¦' }];
        }
    }


    @HostListener('valueChange', ['$event'])
    onChange(value: any) {
        this.applyFilter(
            value === null ?
                this.removeFilter(this.column.dataField) :
                this.updateFilter({
                    field: this.column.dataField,
                    operator: 'eq',
                    value: value
                })
        );
    }


    /*
   * è·å ååæ ¼å¼  ä¸»ä»è¡¨æ¯æ
   * @param dataItem è¡æ°æ®
   * @param field å­æ®µ
   */
    getValue(dataItem: any, field: string) {
        const index = field.indexOf('.');
        if (index < 0) {
            return dataItem[field];
        }
        const fields = field.split('.');
        // fieldå­ç¬¦ä¸²ç»å
        return fields.reduce((result: any, next: any) => {
            return result[next];
        }, dataItem);
    }

}
